import { DATE_FORMAT } from "../../common";
import {Button, Col, DatePicker, Divider, Input, Row} from "antd";
import React, { useRef } from "react";
import { formatDateStrInput } from "../common";
import "./index.css";
import {PostPrecautionForScarSurgery} from "../../common";
import handleAxios, {
    nursingRecordOfOperationDownload,
    PostoperativePrecautionsForScarSurgeryFileDownLoad
} from "../../../../Http/request";
import {generateDateStr} from "../../Details/common";
import {SUBMIT_TYPE} from "../../../../Http/common";

interface P {
  defaultValue: PostPrecautionForScarSurgery;
  newValue?: PostPrecautionForScarSurgery;
  fatherChange(newValue: PostPrecautionForScarSurgery): void;
  saveDraft(newDraft: PostPrecautionForScarSurgery | undefined, saveType: SUBMIT_TYPE): void
}

/**
 * 换药记录单
 */
export default function ({ defaultValue, newValue, fatherChange, saveDraft }: P) {
  // 当前模块的值
  const moduleValue = useRef<PostPrecautionForScarSurgery | undefined>(defaultValue);

  /**
   * 更新模块中的某个值
   */
  const partChange = (newValue: Partial<PostPrecautionForScarSurgery>): void => {
    let newModuleValue: PostPrecautionForScarSurgery;
    if (moduleValue.current === undefined) {
      newModuleValue = { ...defaultValue };
      moduleValue.current = newModuleValue;
    }
    newModuleValue = {
      ...moduleValue.current,
      ...newValue,
    };
    moduleValue.current = newModuleValue;
    fatherChange(newModuleValue);
  };

  return (
    <>
      <Row
        justify="start"
        align="middle"
        className="custom-line-row"
        style={{ marginTop: "10px", marginBottom: "10px" }}
      >
        <Col span={2}>姓名</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.name}
            onChange={(e) => {
              partChange({ name: e.target.value });
            }}
          />
        </Col>
        <Col span={2}>记录时间</Col>
          <Col span={4}>
              <DatePicker
                  style={{ width: "100%" }}
                  showTime={{ format: 'HH:mm' }}
                  defaultValue={formatDateStrInput(defaultValue.recordTimeStr, DATE_FORMAT)}
                  onChange={(value, dateStr: string | string[]) => {
                      if (typeof dateStr === 'string') {
                          partChange({ recordTimeStr: dateStr });
                      } else {
                          partChange({ recordTimeStr: dateStr[0] });
                      }
                  }}
              />
          </Col>
          <Col span={2}>换药时间</Col>
          <Col span={4}>
              <DatePicker
                  style={{ width: "100%" }}
                  showTime={{ format: 'HH:mm' }}
                  defaultValue={formatDateStrInput(defaultValue.dressingChangeTimeStr, DATE_FORMAT)}
                  onChange={(value, dateStr: string | string[]) => {
                      if (typeof dateStr === 'string') {
                          partChange({ dressingChangeTimeStr: dateStr });
                      } else {
                          partChange({ dressingChangeTimeStr: dateStr[0] });
                      }
                  }}
              />
          </Col>
          <Col span={2}>拆线时间</Col>
          <Col span={4}>
              <DatePicker
                  style={{ width: "100%" }}
                  showTime={{ format: 'HH:mm' }}
                  defaultValue={formatDateStrInput(defaultValue.removeStitchesTimeStr, DATE_FORMAT)}
                  onChange={(value, dateStr: string | string[]) => {
                      if (typeof dateStr === 'string') {
                          partChange({ removeStitchesTimeStr: dateStr });
                      } else {
                          partChange({ removeStitchesTimeStr: dateStr[0] });
                      }
                  }}
              />
          </Col>
      </Row>
    <Row
        justify="start"
        align="middle"
        style={{
            marginTop: "10px",
            marginBottom: "10px"
        }}
    >
        <Divider>下载&保存</Divider>
        <Col span={4}>
            <Button
                type={"link"}
                onClick={() => {
                    if (moduleValue.current === undefined) {
                        return
                    } else {
                        PostoperativePrecautionsForScarSurgeryFileDownLoad(moduleValue.current);
                        saveDraft(moduleValue.current, SUBMIT_TYPE.TYPE_MODIFY)
                    }
                }}
            >
                下载疤痕手术术后注意事项
            </Button>
        </Col>
        <Col span={4}>
            <Button
                type={"primary"}
                onClick={() => saveDraft(moduleValue.current, SUBMIT_TYPE.TYPE_MODIFY)}>
                保存疤痕手术术后注意事项草稿
            </Button>
        </Col>
    </Row>
    </>
  );
}